import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ProductListItem from 'components/ProductListItem';
import i18n from 'i18n';
import { addToComparisons, removeFromComparisons } from 'actions/products';

const Heading = (props) => (
  <div className="text-uppercase small font-weight-bold" {...props} />
);

export default function ProductsList({ items, className }) {
  return (
    <Fragment>
      <div className="container d-none d-lg-block">
        <div className="row my-2">
          <div className="col-lg-5 ml-5">
            <Heading>{i18n.t('PRODUCT')}</Heading>
          </div>
          <div className="col-lg-1 ml-5">
            <Heading>{i18n.t('HEALTHY')}</Heading>
          </div>
          <div className="col-lg-2 ml-4">
            <Heading>{i18n.t('TOP_CERTIFICATES')}</Heading>
          </div>
        </div>
      </div>
      <div className={`list-group ${className}`}>
        {items.map((item, index) => (
          <ProductListItem item={item} key={index} />
        ))}
      </div>
    </Fragment>
  );
}

ProductsList.propTypes = {
  items: PropTypes.array,
  className: PropTypes.string
};

ProductsList.default = {
  items: [],
  className: ''
};

export class ProductsListCompare extends Component {
  onSelect = (item) => (e) => {
    const existing = this.props.comparisons.map((i) => i.id).includes(item.id);
    if (existing) this.props.dispatch(removeFromComparisons(item));
    else this.props.dispatch(addToComparisons(item));
  };

  render() {
    const { items, comparisons, dispatch, ...rest } = this.props;
    const ids = comparisons.map((i) => i.id);
    return (
      <div {...rest}>
        <div className="container d-none d-lg-block">
          <div className="row my-2">
            <div className="col-lg-5 ml-5">
              <Heading>{i18n.t('PRODUCT')}</Heading>
            </div>
            <div className="col-lg-1 ml-5">
              <Heading>{i18n.t('HEALTHY')}</Heading>
            </div>
            <div className="col-lg-2 ml-4">
              <Heading>{i18n.t('TOP_CERTIFICATES')}</Heading>
            </div>
          </div>
        </div>
        <div className="list-group">
          {items.map((item, index) => (
            <ProductListItem
              item={item}
              key={index}
              onSelect={this.onSelect(item)}
              selected={ids.includes(item.id)}
              disabled={comparisons.length >= 2 && !ids.includes(item.id)}
            />
          ))}
        </div>
      </div>
    );
  }
}

ProductsListCompare.propTypes = {
  items: PropTypes.array,
  comparisons: PropTypes.array,
  dispatch: PropTypes.func
};
